<template>
    <div class="cc-accessories">
        <div class="cc-accessories__header">
            <div class="cc-accessories__title">{{ translations['Accessories'] }}</div>
        </div>
        <div class="cc-accessories__main">
            <accessory v-for="accessory in accessories.slice(0, 3)" v-bind:key="accessory.id" :accessory="accessory"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Accessory from "./Accessory";

    export default {
        components: {
            Accessory
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                accessories: state => state.accessories,
            }),
        },
        name: 'Accessories',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/accessories";
</style>
